import { useEffect, useRef, useState } from 'react'
import jwtDecode from 'jwt-decode'
import axios from 'axios'
import { Link, Outlet, useNavigate } from 'react-router-dom'
// import { userStore } from '../store/user'
import '../assets/css/app.css'

import Footer from './Footer'
import Sidebar from './Sidebar'
// import './Footer';
// import '../assets/js/bootstrap.js'

// import '../assets/js/pages/dashboard.js'
function Layout({ children }) {
  const navigate = useNavigate()

  function handleSignOut(event) {
    document.getElementById('signInDiv').hidden = false
    document.getElementById('signOutDiv').hidden = true
  }
  const ref = useRef(null)

  function openNav() {
    const element= document.getElementById('sidebar')
    element.style.display = 'block'
    element.classList.add("open");

  }

  function closeNav() {
    // document.getElementById("main").style.marginLeft= "0";
    const refElement = ref.current
    refElement.style.display = 'none'
  }

  return (
    <div className='App'>
      <script src='../style/js/initTheme.js'></script>
      <div id='app'>
        <Sidebar />
        <div id='main'>
          <header className='mb-3'>
            <div className='burger-btn d-block d-xl-none'>
              <i onClick={openNav} className='bi bi-justify fs-3'></i>
            </div>
          </header>
          {/* <div className='page-content'>{children}</div> */}
          <div className='page-content'> <Outlet /> </div>
         <Footer />
        </div>
      </div>
      <script></script>
    </div>
  )
}

export default Layout
